import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { TemplateForm } from '@atlassian/proforma-common-core/form';

const RESOURCE_TYPE_CASE_NOTE = 'CASE_NOTE';

export const caseNoteResource: RouteResource<TemplateForm | null> =
	createResource<TemplateForm | null>({
		type: RESOURCE_TYPE_CASE_NOTE,
		getKey: ({ match }) => `${match.params.projectKey ?? ''}:${match.params.caseNoteId ?? ''}`,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-case-note", jiraSpaEntry: "async-resource-servicedesk-case-note" */ './getData.tsx'
			),
		maxAge: 5 * 60 * 1000,
		isBrowserOnly: true,
	});
